import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import Swal from "sweetalert2";
import VitalsMonitorList from "./Phase-05/VitalsMonitorChart/VitalsMonitorList";
import { selectHasPermission } from "../store/slices/authSlice";

import {
    fetchVitalsCharts,
    deleteVitalsChart,
} from "../store/slices/vitalsSlice";

const VitalsMonitoring = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const canManage = useSelector((state) =>
        selectHasPermission(state, "vital-monitor-manage")
    );
    const canCreate = useSelector((state) =>
        selectHasPermission(state, "vital-monitor-create")
    );
    const canEdit = useSelector((state) =>
        selectHasPermission(state, "vital-monitor-edit")
    );
    const canDelete = useSelector((state) =>
        selectHasPermission(state, "vital-monitor-delete")
    );

    // Redux state
    const { vitalsCharts, isLoading, error } = useSelector((state) => state.vitals);

    // Fetch data on mount
    useEffect(() => {
        if (canManage) {
            dispatch(fetchVitalsCharts());
        }
    }, [dispatch, canManage]);

    // Routing Handlers
    const handleAdd = () => navigate("/phase05/vitals-monitor/add");
    const handleEdit = (id) => navigate(`/phase05/vitals-monitor/edit/${id}`);

    // Delete Handler
    const handleDelete = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This record will be deleted permanently!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteVitalsChart(id));
                Swal.fire("Deleted!", "Record has been removed.", "success");
            }
        });
    };

    if (!canManage)
        return (
            <MainLayout>
                <div className="alert alert-danger mt-3">
                    You do not have permission to manage Vitals Monitoring Charts.
                </div>
            </MainLayout>
        );

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                {error && (
                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        <strong>Error:</strong> {error}
                        <button type="button" className="btn-close" onClick={() => { }}></button>
                    </div>
                )}

                <div className="card">
                    <div className="card-body">
                        <VitalsMonitorList
                            records={vitalsCharts}
                            loading={isLoading}
                            onAdd={canCreate ? handleAdd : null}
                            onEdit={canEdit ? handleEdit : null}
                            onDelete={canDelete ? handleDelete : null}
                        />
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default VitalsMonitoring;
